import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { RewardsNamespace, rewardsReducer } from './store/rewards.store';

@NgModule({
  imports: [StoreModule.forFeature(RewardsNamespace, rewardsReducer)],
})
export class RewardsDataModule {}
